import React, { useState } from "react";
import {
  Button,
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import Alert from "@mui/material/Alert";

function NewTripForm3({ nextStep, prevStep, handleChange, values }) {
  const [errors, setErrors] = useState({});

  const formIsValid = () => {
    const formErrors = {};
    if (Object.keys(values.speciescd).length === 0)
      formErrors.speciescd = "Fishery is required.";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const _next = (event) => {
    event.preventDefault();
    if (!formIsValid()) return;

    nextStep();
  };

  const _cancel = (event) => {
    event.preventDefault();
    prevStep();
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <FormControl
          variant="standard"
          sx={{
            maxWidth: window.innerWidth < 750 ? "75%" : "320px",
            minWidth: window.innerWidth < 750 ? "75%" : "230px",
          }}
        >
          <InputLabel id="speciescd">Fishery</InputLabel>
          <Select
            labelId="speciescd"
            id="speciescd"
            value={values.speciescd}
            onChange={handleChange("speciescd")}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            <MenuItem value="MONKFISH">MONKFISH</MenuItem>
            <MenuItem value="MULTISPECIES">MULTISPECIES</MenuItem>
          </Select>
        </FormControl>
      </Box>
      {errors.speciescd && <Alert severity="error">{errors.speciescd}</Alert>}
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <FormControl variant="standard" component="fieldset">
          <FormLabel component="legend">
            Will you be fishing in the Southern Management Area?
          </FormLabel>
          <RadioGroup
            name="sthrn_mgmt_area_flg"
            id="sthrn_mgmt_area_flg"
            value={values.mgmtArea}
            onChange={handleChange("mgmtArea")}
            row
            className="justifyCenter"
          >
            <FormControlLabel
              value="true"
              control={<Radio color="primary" />}
              label="Yes"
            />
            <FormControlLabel
              value="false"
              control={<Radio color="primary" />}
              label="No"
            />
          </RadioGroup>
        </FormControl>
      </Box>
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Back
          </Button>
        </Box>
        <Box p={1}>
          <Button variant="contained" className="successBtn" onClick={_next}>
            Continue
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default NewTripForm3;
